import axios, { AxiosInstance, AxiosRequestConfig } from "axios";

class Http {
    private instance: AxiosInstance|null = null;

    private get http(): AxiosInstance {
        return this.instance != null ? this.instance : this.initHttp();
      }

    initHttp(){
        const http = axios.create( );
        this.instance = http;
        return http;
    }

    get = <T=any>(url:string,config?:AxiosRequestConfig):Promise<T>=>{
        return this.http.get(url,config);
    }

    post = <T=any>(url:string,data?:any,config?:AxiosRequestConfig):Promise<T>=>{
        return this.http.post(url,data,config);
    }

    put = <T=any>(url:string,data?:any,config?:AxiosRequestConfig):Promise<T>=>{
        return this.http.put(url,data,config);
    }

    delete = <T=any>(url:string,data?:any,config?:AxiosRequestConfig):Promise<T>=>{
    config = config ?? {data:data};
    return this.http.delete(url,config);
    }
}

const http = new Http();

export default http;
